import * as api from "../../shared/api";
import apiPath from "../../shared/apiPath";
import * as biz_data_helper from "../../shared/biz_data_helper";

const content_type = "";

const create = function () {
  return {
    content_type: "muji"
  };
};
const fields = [
  {
    key: "id",
    label: "编号",
    type: "button",
    button: { type: "text" },
    thStyle: { width: "60px" }
    // isRowHeader:true,
  },
  {
    key: "name",
    label: "权限名称",
    sortable: true
  },
  {
    key: "code",
    label: "权限编码",
    sortable: true
  },
  {
    key: "category",
    label: "权限类别"
  },
  {
    key: "ext",
    label: "控制点",
    thStyle: {
      width: "50rem"
    }
  },
  {
    key: "description",
    label: "备注",
    sortable: true
  },
  {
    key: "is_valid",
    label: "状态",
    type: "boolean"
  }
];

const dataForm = {
  id: 0,
  name: "",
  category: "",
  description: "",
  is_valid: false,
  ext: null
};

///前端验证
const rules = {
  name: [{ required: true, message: "请输入权限名称", trigger: "blur" }]
};

const descriptor = {};

const methods = {
  ///get
  async getData() {
    const biz_data = new biz_data_helper.base_entity_helper(
      "get_privilege_list",
      {},
      {}
    );
    let _fields = _.map(fields, "key");
    _fields.push("ext");

    let result = await biz_data
      .execAction({
        params: {},
        fields: _fields
      })
      .run();

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data;
    } else {
      return null;
    }
  }
};

export { fields, dataForm, methods, rules };
